var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33028 7.2258V19.3439C4.33028 19.4389 4.36084 19.517 4.42193 19.5781C4.48302 19.6393 4.56109 19.6697 4.65612 19.6697H19.3439C19.4389 19.6697 19.517 19.6393 19.5781 19.5781C19.6392 19.517 19.6697 19.4389 19.6697 19.3439V7.2258H4.33028ZM4.73756 21C4.28394 21 3.88094 20.8239 3.52856 20.4715C3.17619 20.1191 3 19.7161 3 19.2625V6.5831C3 6.39578 3.02975 6.21469 3.08926 6.03964C3.14877 5.86469 3.23804 5.70328 3.35703 5.55551L4.87198 3.6286C5.01949 3.43259 5.20848 3.27887 5.43896 3.16736C5.66943 3.05585 5.91346 3 6.17107 3H17.7977C18.0553 3 18.301 3.05585 18.5349 3.16736C18.7688 3.27887 18.9595 3.43259 19.107 3.6286L20.643 5.57584C20.762 5.72369 20.8512 5.88675 20.9107 6.06509C20.9702 6.24353 21 6.42636 21 6.61368V19.2625C21 19.7161 20.8238 20.1191 20.4714 20.4715C20.1191 20.8239 19.7161 21 19.2624 21H4.73756ZM4.75449 5.89554H19.2177L18.0323 4.44232C17.9984 4.40836 17.9593 4.38126 17.9152 4.36084C17.8711 4.34052 17.8252 4.33035 17.7778 4.33035H6.1921C6.14458 4.33035 6.09764 4.34052 6.05125 4.36084C6.00488 4.38126 5.96697 4.40836 5.93756 4.44232L4.75449 5.89554Z",
    fill: "#0198D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFileIcon);
export default __webpack_public_path__ + "static/media/blue-file-icon.3c87421a16f7493b730d61e5d3a26892.svg";
export { ForwardRef as ReactComponent };